module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/downloads-folder-a4c2e426dd3de61221c2946f4f6645db.svg";